import { ActionTree } from 'vuex'
import { RootState } from '@/store/types'
import ImagenesSatelitalesService, { ImagenesSatelitalesInterface } from '@/domain/services/ImagenesSatelitalesService'
import { ImagenesSatelitalesState, StoreError } from '@/store/modules/imagenes-satelitales/types'

const imagenesSatelitalesService: ImagenesSatelitalesInterface = new ImagenesSatelitalesService()

export const actions: ActionTree<ImagenesSatelitalesState, RootState> = {
  async getImagenesSatelitales ({ commit }): Promise<any> {
    try {
      const actionResponse = await imagenesSatelitalesService.getImagenesSatelitales()
      return commit(actionResponse.type, actionResponse.payload)
    } catch (error) {
      const storeError: StoreError = { state: true, message: error, name: 'STORE_ERROR' }
      return commit('STORE_ERROR', storeError)
    }
  }
}
